import { render } from "./PlayerIdentityAuthentication.vue?vue&type=template&id=0a7bcf4e&scoped=true"
import script from "./PlayerIdentityAuthentication.vue?vue&type=script&lang=js"
export * from "./PlayerIdentityAuthentication.vue?vue&type=script&lang=js"

import "./PlayerIdentityAuthentication.vue?vue&type=style&index=0&id=0a7bcf4e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\JavonOnuigbo\\mgs\\RabbitsfootOperatorApps\\cashierpanel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a7bcf4e"]])

export default __exports__